import { render, staticRenderFns } from "./promotionDialog.vue?vue&type=template&id=0ced4743&scoped=true"
import script from "./promotionDialog.vue?vue&type=script&lang=js"
export * from "./promotionDialog.vue?vue&type=script&lang=js"
import style0 from "./promotionDialog.vue?vue&type=style&index=0&id=0ced4743&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ced4743",
  null
  
)

export default component.exports